import { gql } from "@apollo/client";
import { IntegrationThirdParty, IntegrationType } from "./companyIntegrationLimitation";


export const COMPANY_INTEGRATIONS = gql`
query ExtendedCompanies($input: BasicQueryInfoInput) {
	user {
		extendedCompanies(input: $input) {
			integrations {
				third_party_id
				fk_company
				description
				integration_jwt
				integration_expiration
				fk_integration_type
				integrationType {
					integration_type_id
					integration_name
					description
					access_level
				}
				fk_integration_access
				integrationAccess {
					integration_access_id
					weight
					temp
					water
				}
			}
			integrationLimitations {
				integration_type_id
				integration_name
				description
				access_level
			}
		}
	}
}
`

export interface CompanyIntegrationsResponse {
	user: {
		extendedCompanies: {
			integrations: IntegrationThirdParty[]
			integrationLimitations: IntegrationType[]
		}[]
	}
}

